import { Button, Col, Form, Input, Row, Table, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { DatePicker as DatePickerJalali, JalaliLocaleListener } from "antd-jalali";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDealer } from "../../../../tools/api";
import { convertToGregorian, convertToJalaliWithoutTime } from "../../../../tools/tools";
import { NotFound } from "../../../../sources/svg/svg";
import Loading from "../../../auxiliary/loader/loading";
import { _adr } from "../../../../address";

const NewRequestList = () => {
	const [frmSearch] = Form.useForm();
	const nav = useNavigate();
	const [messageApi, contextHolder] = message.useMessage();

	const { queryRegisterKitRequestDistributer } = useDealer();
	const { _currentUser } = useSelector((state) => state?.another);

	const [tableData, setTableData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	// state current page show Records
	const [currentPage, setCurrentPage] = useState(0);
	// state totalRecord
	const [totalRecord, setTotalRecord] = useState(0);

	const handleSearch = async () => {
		setIsLoading(true);
		try {
			const values = frmSearch.getFieldsValue();

			const payload = {
				searchConfigModel: {
					sort: "",
					filter: values?.username || "",
					entriesPerPage: 10,
					page: currentPage === 0 ? 0 : currentPage - 1,
					totalRowCount: 0,
				},
				userName: values?.username || "",
				requestStatus: 1,
			};

			if (values?.fromdate) {
				payload.fromApprovalDate = convertToGregorian(values.fromdate.format("YYYY-MM-DD"), "-", "-");
			}

			if (values?.todate) {
				payload.toApprovalDate = convertToGregorian(values.todate.format("YYYY-MM-DD"), "-", "-");
			}

			const response = await queryRegisterKitRequestDistributer(payload);

			if (response) {
				const result = response?.Result || [];
				if (values?.username && result.length === 0) {
					messageApi.open({ type: "error", content: "نام کاربری وارد شده صحیح نیست." });
				}
				setTableData(result);
				setTotalRecord(response?.searchconfigmodel?.totalrowcount || 0);
			}
		} catch (error) {
			console.error("Failed to load distributor kit requests:", error);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		handleSearch();
	}, [currentPage]);

	const handleAssign = (item) => {
		nav(_adr.Root + _adr.SimLocked.Dealer.Index + _adr.SimLocked.Dealer.AssignKitDetail, { state: item });
	};

	const columns = [
		{
			title: "تاریخ تایید",
			dataIndex: "adminApprovalDate",
			key: "adminApprovalDate",
			width: 150,
			sorter: (a, b) => new Date(a.rawApprovalDate || 0) - new Date(b.rawApprovalDate || 0),
		},
		{
			title: "تعداد کیت",
			dataIndex: "requestedQuantity",
			key: "requestedQuantity",
			width: 110,
		},
		{
			title: "نام کاربری نماینده",
			dataIndex: "userName",
			key: "userName",
			width: 150,
		},
		{
			title: "نوع مخزن",
			dataIndex: "poolType",
			key: "poolType",
			width: 180,
		},
		{
			title: "آدرس",
			dataIndex: "address",
			key: "address",
			width: 200,
		},
		{
			title: "تلفن",
			dataIndex: "telNoOne",
			key: "telNoOne",
			width: 150,
		},
		{
			title: "عملیات",
			dataIndex: "action",
			key: "action",
			width: 120,
		},
	];

	const dataSource = tableData.map((item, key) => ({
		key,
		rawApprovalDate: item.adminApprovalDate,
		adminApprovalDate: convertToJalaliWithoutTime(item.adminApprovalDate),
		requestedQuantity: item.requestedQuantity,
		userName: item.userName,
		poolType: item.poolType,
		address: item.address,
		telNoOne: <span dir="ltr">{item.telNoOne}</span>,
		action: (
			<Button className="btn-normal btn-aptel" onClick={() => handleAssign(item)}>
				تخصیص
			</Button>
		),
	}));

	return (
		<>
			{contextHolder}
			<div className="holder-form-filter">
				<Form form={frmSearch} layout="vertical" onFinish={handleSearch}>
					<Row gutter={16} align="bottom">
						<Col>
							<JalaliLocaleListener />
							<Form.Item className="input-normal" name="fromdate" label="از تاریخ">
								<DatePickerJalali format="YYYY/MM/DD" placeholder="از تاریخ" />
							</Form.Item>
						</Col>
						<Col>
							<Form.Item className="input-normal" name="todate" label="تا تاریخ">
								<DatePickerJalali format="YYYY/MM/DD" placeholder="تا تاریخ" />
							</Form.Item>
						</Col>
						<Col>
							<Form.Item className="input-normal" name="username" label="نام کاربری نماینده">
								<Input placeholder="نام کاربری نماینده" allowClear dir="ltr" />
							</Form.Item>
						</Col>
						<Col>
							<Form.Item label="&nbsp;">
								<Button htmlType="submit" className="btn-normal btn-aptel" icon={<SearchOutlined />} />
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</div>

			<div className="holder-table">
				<Table
					className="tbl-normal"
					columns={columns}
					locale={{
						emptyText: <NotFound text={"رکوردی یافت نشد."} />,
					}}
					pagination={{
						className: "page-pagination",
						onChange: (page) => {
							setCurrentPage(page);
						},
						pageSize: 10,
						align: "start",
						current: currentPage === 0 ? 1 : currentPage,
						total: totalRecord,
						showSizeChanger: false,
					}}
					scroll={{ y: "100%" }}
					dataSource={dataSource}
				/>
			</div>

			<Loading isOpen={isLoading} />
		</>
	);
};

export default NewRequestList;
